import { stageVars } from "./main";

let chosenPortfolio = "maximumGrowth";
let startingValue = 10000;
const startingRates = {
    maximumGrowth: 2.01034589752299,
    growth: 1.83111784108746,
    balanced: 1.65830950091105
};

const gains = {
    maximumGrowth: {
        step1: {
            yes: 1.51105105858977,
            no: 1.1010612968516
        },
        step2: {
            yes: 1.06508460110566,
            no: 1.04768655245638
        },
        step3: {
            yes: 1.57235057830968,
            no: 1.0347521505742
        }
    },
    growth: {
        step1: {
            yes: 1.54223083879182,
            no: 1.1010612968516
        },
        step2: {
            yes: 1.08086849830822,
            no: 1.04768655245638
        },
        step3: {
            yes: 1.38184454024182,
            no: 1.0347521505742
        }
    },
    balanced: {
        step1: {
            yes: 1.5586350560413,
            no: 1.1010612968516
        },
        step2: {
            yes: 1.09233538181249,
            no: 1.04768655245638
        },
        step3: {
            yes: 1.21079110656385,
            no: 1.0347521505742
        }
    }
};
let selectedStartingValue = startingRates[chosenPortfolio] * startingValue;

const preBrexitAmountRates = {
    maximumGrowth: 3.123349,
    growth: 2.804394,
    balanced: 2.48157
};

const prePandemicAmountRates = {
    maximumGrowth: 0.83117134,
    growth: 0.88352242,
    balanced: 0.93675595
};

function generateAllFlowsPortfolioValues(chosenPortfolio) {
    let selectedGains = gains[chosenPortfolio];

    const allFlowsPortfolioValues = {
        invest: {
            invest: {
                invest: [
                    (selectedStartingValue * selectedGains.step1.yes).toFixed(0),
                    (selectedStartingValue * selectedGains.step1.yes * selectedGains.step2.yes).toFixed(0),
                    (
                        selectedStartingValue *
                        selectedGains.step1.yes *
                        selectedGains.step2.yes *
                        selectedGains.step3.yes
                    ).toFixed(0)
                ],
                cash: [
                    (selectedStartingValue * selectedGains.step1.yes).toFixed(0),
                    (selectedStartingValue * selectedGains.step1.yes * selectedGains.step2.yes).toFixed(0),
                    (
                        selectedStartingValue *
                        selectedGains.step1.yes *
                        selectedGains.step2.yes *
                        selectedGains.step3.no
                    ).toFixed(0)
                ]
            },
            cash: {
                invest: [
                    (selectedStartingValue * selectedGains.step1.yes).toFixed(0),
                    (selectedStartingValue * selectedGains.step1.yes * selectedGains.step2.no).toFixed(0),
                    (
                        selectedStartingValue *
                        selectedGains.step1.yes *
                        selectedGains.step2.no *
                        selectedGains.step3.yes
                    ).toFixed(0)
                ],
                cash: [
                    (selectedStartingValue * selectedGains.step1.yes).toFixed(0),
                    (selectedStartingValue * selectedGains.step1.yes * selectedGains.step2.no).toFixed(0),
                    (
                        selectedStartingValue *
                        selectedGains.step1.yes *
                        selectedGains.step2.no *
                        selectedGains.step3.no
                    ).toFixed(0)
                ]
            }
        },
        cash: {
            invest: {
                invest: [
                    (selectedStartingValue * selectedGains.step1.no).toFixed(0),
                    (selectedStartingValue * selectedGains.step1.no * selectedGains.step2.yes).toFixed(0),
                    (
                        selectedStartingValue *
                        selectedGains.step1.no *
                        selectedGains.step2.yes *
                        selectedGains.step3.yes
                    ).toFixed(0)
                ],
                cash: [
                    (selectedStartingValue * selectedGains.step1.no).toFixed(0),
                    (selectedStartingValue * selectedGains.step1.no * selectedGains.step2.yes).toFixed(0),
                    (
                        selectedStartingValue *
                        selectedGains.step1.no *
                        selectedGains.step2.yes *
                        selectedGains.step3.no
                    ).toFixed(0)
                ]
            },
            cash: {
                invest: [
                    (selectedStartingValue * selectedGains.step1.no).toFixed(0),
                    (selectedStartingValue * selectedGains.step1.no * selectedGains.step2.no).toFixed(0),
                    (
                        selectedStartingValue *
                        selectedGains.step1.no *
                        selectedGains.step2.no *
                        selectedGains.step3.yes
                    ).toFixed(0)
                ],
                cash: [
                    (selectedStartingValue * selectedGains.step1.no).toFixed(0),
                    (selectedStartingValue * selectedGains.step1.no * selectedGains.step2.no).toFixed(0),
                    (
                        selectedStartingValue *
                        selectedGains.step1.no *
                        selectedGains.step2.no *
                        selectedGains.step3.no
                    ).toFixed(0)
                ]
            }
        }
    };
    return allFlowsPortfolioValues;
}

function getVolatilityVideoResults([decisionOne, decisionTwo, decisionThree]) {
    const generatedValues =
        generateAllFlowsPortfolioValues(chosenPortfolio)[
            decisionOne === "i" || decisionOne === "" || decisionOne === "invest" ? "invest" : "cash"
        ][decisionTwo === "i" || decisionTwo === "" || decisionTwo === "invest" ? "invest" : "cash"][
            decisionThree === "i" || decisionThree === "" || decisionThree === "invest" ? "invest" : "cash"
        ];
    if (stageVars) {
        chosenPortfolio = stageVars.chosenPortfolio;
        startingValue = +stageVars.investmentAmount;
        selectedStartingValue = startingRates[chosenPortfolio] * startingValue;
        stageVars.stageZeroPortfolioWorth = selectedStartingValue;
        stageVars.preBrexitPortfolioWorth = stageVars.investmentAmount * preBrexitAmountRates[chosenPortfolio];
        stageVars.prePandemicPortfolioWorth = +generatedValues[1] / prePandemicAmountRates[chosenPortfolio];
    }
    return generatedValues;
}

export { getVolatilityVideoResults };
